import $ from 'cash-dom'

// modules (a-z)
import AccordionList from './modules/accordion-list'
import ResourceTiles from './modules/resource-tiles'
import ContactDetails from './modules/contact-details'
import Header from './modules/header'
import StatCards from './modules/stat-cards'
import StoryCards from './modules/story-cards'
import Video from './modules/video'

// init modules (order of importance)
$(() => {
  Header.init()
  StatCards.init()
  StoryCards.init()
  Video.init()
  AccordionList.init()
  ResourceTiles.init()
  ContactDetails.init()
})
